import { Component, HostBinding, Input } from "@angular/core";

@Component({
    selector: "page-content",
    template: ` <ng-content></ng-content>`,
    styleUrls: ["./page-content.component.scss"],
    standalone: false
})
export class PageContentComponent {
  /**
   * Sets width and height to 100% so that the complete content space is filled. Default: true
   */
  @HostBinding("class.full-space") @Input() fullSpace = true;
  /**
   * Sets padding to 32px. To enable full-width content, set this to false. Default: true
   */
  @HostBinding("class.padding") @Input() padding = true;
}
